import React, { useState } from 'react';
import SEO from '../components/SEO';
import './StaticPage.css';

const MAX_SUBJECT = 100;
const MAX_MESSAGE = 500;

const ContactPage = () => {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'subject' && value.length > MAX_SUBJECT) return;
    if (name === 'message' && value.length > MAX_MESSAGE) return;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');

    try {
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          access_key: '020a0603-de8b-4ee8-8cb6-c2ad38936579',
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
        }),
      });
      const data = await res.json();
      if (data.success) {
        setSubmitted(true);
      } else {
        setError('Something went wrong. Please try again or email us directly.');
      }
    } catch {
      setError('Network error. Please try again or email us directly.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="static-page">
      <SEO
        title="Contact Us"
        description="Contact SarkariNaukriRajasthan.com – send us your questions, suggestions, or report issues about government job listings."
        path="/contact"
      />
      <h1 className="static-page-title">Contact Us</h1>

      <section className="static-section">
        <p>
          Have questions, suggestions, or want to report an issue? We'd love to hear from you.
          Fill out the form below or reach us directly via email.
        </p>
      </section>

      <section className="static-section">
        <h2>Get in Touch</h2>
        <div className="contact-info-grid">
          <div className="contact-info-card">
            <span className="contact-icon">📧</span>
            <h3>Email</h3>
            <a href="mailto:sarkarinaukrirajasthanjobs@gmail.com">sarkarinaukrirajasthanjobs@gmail.com</a>
          </div>
          <div className="contact-info-card">
            <span className="contact-icon">🌐</span>
            <h3>Website</h3>
            <p>www.sarkarinaukrirajasthan.com</p>
          </div>
          <div className="contact-info-card">
            <span className="contact-icon">📍</span>
            <h3>Location</h3>
            <p>Rajasthan, India</p>
          </div>
        </div>
      </section>

      <section className="static-section">
        <h2>Send Us a Message</h2>
        {submitted ? (
          <div className="contact-success">
            <span className="contact-success-icon">✅</span>
            <p>Thank you! Your message has been sent successfully. We'll get back to you soon.</p>
          </div>
        ) : (
          <form className="contact-form" onSubmit={handleSubmit}>
            {error && <p className="contact-error">{error}</p>}
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Your Name</label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required placeholder="Enter your name" />
              </div>
              <div className="form-group">
                <label htmlFor="email">Your Email</label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required placeholder="Enter your email" />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="subject">Subject <span className="char-count">{formData.subject.length}/{MAX_SUBJECT}</span></label>
              <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required placeholder="What is this about?" />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message <span className="char-count">{formData.message.length}/{MAX_MESSAGE}</span></label>
              <textarea id="message" name="message" rows="5" value={formData.message} onChange={handleChange} required placeholder="Write your message here..." />
            </div>
            <button type="submit" className="btn-submit" disabled={submitting}>
              {submitting ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        )}
      </section>
    </div>
  );
};

export default ContactPage;
